import React from "react"

const Map = () => (
  <div className="footer__map">
    <iframe title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2366.925498491323!2d-113.38149058447281!3d53.61263158003569!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x53a03c87f06a5fdd%3A0xfb168042c492d374!2sFraser%20Community%20Child%20Care%20Center%20%26%20Out%20Of%20School%20Care!5e0!3m2!1sen!2sca!4v1597096763064!5m2!1sen!2sca" width="600" height="450" frameborder="0"></iframe>
  </div>
)

export default Map